export const parseRawAmount = (text: string, prefix: string) =>
  parseInt(
    text
      .toString()
      .replace(/,/g, '')
      .replace(prefix, ''),
    10,
  )
